import { BriefClosureStatus } from "@shared/lib/types/brief";
import styles from "../styles.module.scss";

export const CLOSURE_TABS = [
  {
    value: BriefClosureStatus.Open,
    label: "Active closures",
    countClass: styles.tabCountActiveOpen,
    title: "Active closures",
    description:
      "Purchase done on the campaign brief — open a project to send confirmation mail.",
    empty: "No active closures — nothing awaiting confirmation mail.",
  },
  {
    value: BriefClosureStatus.Closed,
    label: "Closed closures",
    countClass: styles.tabCountActiveClosed,
    title: "Closed closures",
    description:
      "Every tracked creator on the brief has purchase done and confirmation mail recorded.",
    empty: "No fully closed briefs yet.",
  },
] as const;
